export const environment = {
  production: false,
  useMockData: true,
  apiUrl: 'https://passport-back.dev1.venusium.cloud/passeport', // URL de l'API pour les tests
  appName: 'Passeport Medical',
  version: '1.0.0',

  // Configuration des timeouts
  httpTimeout: 15000, // 15 secondes pour les tests

  // Configuration des retry
  maxRetries: 1,
  retryDelay: 500, // 500ms pour les tests

  // Configuration des logs
  enableLogs: true,
  logLevel: 'warn',

  // Configuration de l'authentification
  auth: {
    tokenKey: 'passeport_token_test',
    refreshTokenKey: 'passeport_refresh_token_test',
    tokenExpiryKey: 'passeport_token_expiry_test',
    autoRefresh: false, // Désactivé pour les tests
    refreshThreshold: 5 * 60 * 1000, // 5 minutes avant expiration
  },

  // Configuration des uploads
  upload: {
    maxFileSize: 5 * 1024 * 1024, // 5MB pour les tests
    allowedTypes: ['image/*', 'application/pdf'],
    maxFiles: 3,
  },

  // Configuration des notifications
  notifications: {
    position: 'top-right',
    duration: 2000,
    enableSound: false,
  },

  // Configuration des features
  features: {
    enableOfflineMode: false,
    enablePushNotifications: false,
    enableAnalytics: false,
  },

  // Configuration OneSignal Web Push
  oneSignal: {
    appId: '',
    safariWebId: '',
    serviceWorkerPath: 'OneSignalSDKWorker.js',
    serviceWorkerUpdaterPath: 'OneSignalSDKUpdaterWorker.js',
    sdkUrl: 'https://cdn.onesignal.com/sdks/web/v16/OneSignalSDK.page.js',
    allowLocalhostAsSecureOrigin: true,
  },

  // Configuration Google Maps
  googleMaps: {
    apiKey: 'AIzaSyDbOznBcfBFHISn0i381WED65meKHTRlhg',
    defaultZoom: 15,
    defaultHeight: '200px',
  },
  paymentToken: 'test_public-52ea4aba-8343-4362-87b4-cba7aeb54731.F9zzFQmHyVEyDv9sGfxwJWXEScwGDIccKSBpKZuyDIobK1YAnAsUUVMFmDhiYClc'

};
